// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__6bcrT","selects":"Documents_selects__3Yi-D"};